module.exports = __webpack_public_path__ + "img/emoji-crying.f188b8a5.webp";